import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Clients } from "@/components/site/Clients";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { Proof } from "@/components/site/Proof";
import { Booking } from "@/components/site/Booking";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="bg-ink-900 min-h-screen">
      <div className="noise-overlay" aria-hidden />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Clients />
        <Services />
        <Manifesto />
        <Proof />
        <Booking />
      </main>
      <Footer />
    </div>
  );
}
